import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import TestingReports from './components/TestingReports/TestingReports';

const Reports = () => {
  return renderComponent(<TestingReports />);
};

export default Reports;
